<template>
  <q-table
    flat
    bordered
    :data="reports"
    row-key="id"
    :columns="captureColumns"
    :pagination="pagination"
    no-data-label="Não foram encontrados resultados, de acordo com os filtros informados."
  >
    <template v-slot:body-cell-clickId="props">
      <q-td :props="props">
        {{ props.row.clickId?.length > 24 ? props.row.clickId.substring(0, 24) + '...' : props.row.clickId }}
        <q-tooltip
          v-if="props.row.clickId?.length > 24"
          content-class="bg-secondary text-white"
          content-style="font-size: 12px"
          anchor="top middle"
          self="bottom middle"
        >
          {{ props.row.clickId }}
        </q-tooltip>
      </q-td>
    </template>

    <template v-slot:body-cell-price="props">
      <q-td :props="props">
        {{ !isNaN(props.row.price) ? parseMoney(props.row.price) : props.row.price }}
      </q-td>
    </template>

    <template v-slot:bottom>
      <!-- <pagination-table
        @change="getCaptureReport"
        :data="reqPagination"
        :pagination="pagination"
      /> -->
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        Total:{{ reqPagination.total }}
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
  </q-table>
</template>

<script>
import ReportMixin from '../../mixins/ReportMixin';
//import PaginationTable from "../../widgets/PaginationTable.vue";
export default {
  //  components: { PaginationTable },
  name: 'ListCaptureReports',
  mixins: [ReportMixin],

  data() {
    return {
      captureColumns: [
        {
          name: 'orderId',
          required: true,
          label: 'Order ID',
          align: 'left',
          field: 'orderId',
          sortable: true
        },
        {
          name: 'actionId',
          required: true,
          label: 'Action ID',
          align: 'left',
          field: 'actionId',
          sortable: true
        },
        {
          name: 'status',
          required: true,
          label: 'Status',
          align: 'left',
          field: 'status',
          sortable: true,
          format: (status) => this.labelStatus(status)
        },
        {
          name: 'clickId',
          required: true,
          label: 'Click ID',
          align: 'left',
          field: 'clickId',
          sortable: true
        },
        {
          name: 'cookieId',
          required: true,
          label: 'Cookie ID',
          align: 'left',
          field: 'cookieId',
          sortable: true
        },
        {
          name: 'dateCreated',
          required: true,
          label: this.$t('created_at'),
          align: 'left',
          field: 'dateCreated',
          sortable: true
        },
        {
          name: 'objId',
          required: true,
          label: 'OBJ ID',
          align: 'left',
          field: 'objId',
          sortable: true
        },
        {
          name: 'price',
          required: true,
          label: this.$t('price'),
          align: 'left',
          field: 'price',
          sortable: true
        }
      ],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: 10
      }
    };
  },

  watch: {
    currentPage() {
      if (this.reqPagination.from != this.reqPagination.current_page) {
        this.getCaptureReport(`%26page=${this.currentPage}`, `%26perPage=${this.pagination.rowsPerPage}`);
      }
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    }
  },

  created() {
    this.ActionSetFilterReports();
    this.ActionSetReports();
    this.getCaptureReport(null, '&per_page=1' + this.pagination.rowsPerPage);
},

  methods: {
    labelStatus(status) {
      switch (status) {
        case '0':
          return this.$t('created');
        case '1':
          return this.$t('approved');
        case '2':
          return this.$t('denied');
        case '3':
          return this.$t('denied_incomplete_data');
        case '4':
          return this.$t('denied_preparation_error');
        case '5':
          return this.$t('denied_excess_characters');
        case '6':
          return this.$t('denied_invalid_values');
        case '7':
          return this.$t('denied_duplicate_transaction');
        case '8':
          return this.$t('denied_save_failure');
        case '9':
          return this.$t('denied_duplicate_transaction_exclusive');
        case '10':
          return this.$t('denied_campaign_not_found');
        case '11':
          return this.$t('denied_price_cleanup_error');
        case '12':
          return this.$t('denied_price_conversion_error');
        case '13':
          return this.$t('denied_creative_id_cleanup_error');
        case '14':
          return this.$t('denied_transaction_build_failure');
        case '15':
          return this.$t('denied_raw_transactions_save_failure');
        case '16':
          return this.$t('denied_awaiting_possible_click');
        case '23':
          return this.$t('sent_to_raw_transactions');
        case '24':
          return this.$t('received_in_raw_transactions');
        case '17':
          return this.$t('blocked_channel_removed');
        case '18':
          return this.$t('denied_cookie_time_expired');
        case '19':
          return this.$t('cap_reached');
        default:
          return '';
      }
    }
  }
};

</script>
